module.exports = __webpack_public_path__ + "assets/img/memory_leak_external.578a503c.jpg";